import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { Button } from '@picsio/ui';

import withErrorBoundary from '../ErrorBoundary/withErrorBoundary';
import Icon from '../Icon';
import l18n from '../../shared/strings';
import s from './styles.module.scss';

function PrepareMediaForShopifyDialog({
  assets,
  onPrepare,
  onAssetCopy,
  onCancel,
}) {
  const strings = l18n.DIALOGS.PREPARE_MEDIA_FOR_SHOPIFY;
  const count = assets.length;

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <div className={`simpleDialog ${s.dialog}`}>
      <div className="simpleDialogUnderlayer" />
      <div className="simpleDialogBox">
        <div className="simpleDialogHeader">
          <h2 className="simpleDialogTitle">{strings.TITLE}</h2>
          <button
            className="simpleDialogBtnCross"
            type="button"
            onClick={handleCancel}
          >
            <Icon name="close" />
          </button>
        </div>
        <div className="simpleDialogContent">
          <div className={`simpleDialogContentInner ${s.contentInner}`}>
            <p>{strings.DESCRIPTION(count)}</p>
            {assets.map((asset) => (
              <div key={asset._id} className={s.fileRow}>
                <div className={s.issueBlock}>
                  <span className={s.label}>{strings.ISSUE_LABEL}</span>
                  <span className={s.value}>{strings.ISSUE_UNSUPPORTED_FORMAT}</span>
                </div>
                <div className={s.fileBlock}>
                  <span className={s.label}>{strings.FILE_LABEL}</span>
                  <span className={s.value} title={asset.name}>{asset.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={`simpleDialogFooter ${s.footer}`}>
          <Button
            color="secondary"
            size="md"
            variant="contained"
            componentProps={{ 'data-testid': 'btnPrepareMediaCancel' }}
            onClick={handleCancel}
          >
            {strings.BTN_CANCEL}
          </Button>
          <Button
            color="secondary"
            size="md"
            variant="contained"
            componentProps={{ 'data-testid': 'btnPrepareMediaAssetCopy' }}
            onClick={onAssetCopy}
          >
            {strings.BTN_ASSET_COPY}
          </Button>
          <Button
            color="primary"
            size="md"
            variant="contained"
            componentProps={{ 'data-testid': 'btnPrepareMediaPrepare' }}
            onClick={onPrepare}
          >
            {strings.BTN_PREPARE}
          </Button>
        </div>
      </div>
    </div>
  );
}

PrepareMediaForShopifyDialog.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string,
  })).isRequired,
  onPrepare: PropTypes.func.isRequired,
  onAssetCopy: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default withErrorBoundary(PrepareMediaForShopifyDialog, {
  className: 'errorBoundaryOverlay',
});
